/**
 * This file is created manually
 * You can change the content
 *
 */

import P from './typography/P'
export * from './typography/P'
export default P
